import React from "react";
import { Link } from "react-router-dom";

const IconHrefButton = ({ children, to = "/", ...props }) => {
  return (
    <Link
      to={to}
      className="
      inline-flex h-10 w-10 items-center justify-center rounded-xl bg-transparent text-muted
      transition-all duration-200 hover:bg-raised hover:text-ink active:scale-[0.97]
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20"
      {...props}
    >
      {children}
    </Link>
  );
};

export default IconHrefButton;
